import React from 'react';
import $ from 'jquery';
import classNames from 'classnames';
import T from 'i18n-react';
import CopyToClipboard, {onCopy} from 'react-copy-to-clipboard';
import TextTransition, { presets } from "react-text-transition";
import copy from 'copy-to-clipboard';

class ComponentCopyToClipboard extends React.Component {
  constructor(props) {
    super(props);
    let valueToSet = "";
    if (location.search.includes("?")) {
      valueToSet = location.origin + location.pathname + location.search + '&step=' + this.props.data.Id
    } else {
      valueToSet = location.origin + location.pathname + location.search + '?step=' + this.props.data.Id
    }
    this.state = {
      value: valueToSet,
      copied: false,
      linkText: T.translate("steps.copyLink"),
      copiedText: T.translate("steps.copiedText")
    }
  }

  onCopyLink = () => {
    this.setState({ copied: true });

    setTimeout(() => {
        this.setState({ copied: false });
      }, 2500);
  }

  onKeyDown = (e) => {
    const { value } = this.state;
    if (e.key === 'Enter') {
      let result = copy(value);
      e.preventDefault();
      document.execCommand('copy');
      this.onCopyLink(value, result);
      
    }
  }

  render() {
    const { linkText, value, copied, copiedText } = this.state;

    const classes = classNames({
      'element-link element-link--copy': true
    });

    return (
      <>
        <CopyToClipboard text={value}
        onCopy={() => this.onCopyLink()} tabIndex="0">
          <a className={classes} onKeyDown={(e) => this.onKeyDown(e)} aria-label={copied ? copiedText : linkText}>
              <TextTransition
                  text={copied ? copiedText : linkText}
                  springConfig={ presets.gentle }
                  noOverflow={true}
              />
          </a>
        </CopyToClipboard>
      </>

    );
  }
};

export default ComponentCopyToClipboard;
